import { ApiService } from '../../constants';
import { HttpService } from '../../utilities';

export const getRnB = (month, year) => {
  if (month === null) {
    // month now
    month = new Date().getMonth() + 1;
  }
  if (year === null) {
    // year now
    year = new Date().getFullYear();
  }
  return HttpService.get(
    `${ApiService.icdc.module.profile.rnb}?month=${month || ''}&year=${
      year || ''
    }`
  );
};

export const getRedeem = () => {
  return HttpService.get(`${ApiService.icdc.module.profile.redeem}`);
};

export const saveImage = (data) => {
  return HttpService.post(ApiService.icdc.module.badge.uploadImage, data);
};
